import { type Location } from '@koala/sdk';
import { LocationPill } from './location-pill';
import { SelectLocationModal } from './select-location-modal';
import { useLocationPickerState } from './use-location-picker-state';

interface Props {
  location: Pick<Location, 'label' | 'cached_data'>;
  conveyanceType?: string | null;
  accentPin?: boolean;
}

/**
 * The Location Pill wired to the Select Location pop-up (TEAM-13315). Single-location
 * brands get the pill without a change action.
 */
export function LocationPicker({ location, conveyanceType, accentPin }: Props) {
  const { canChange, busy } = useLocationPickerState();

  if (!canChange) {
    return (
      <LocationPill location={location} conveyanceType={conveyanceType} accentPin={accentPin} />
    );
  }

  return (
    <SelectLocationModal
      trigger={(open) => (
        <LocationPill
          location={location}
          conveyanceType={conveyanceType}
          onChange={open}
          disabled={busy}
          accentPin={accentPin}
        />
      )}
    />
  );
}
